import { NextPage } from 'next';

import PWALayout from '@/layouts/AlphaLayout';
import Profiles from '@/modules/AlphaPWA/Profiles';

const ProfilesPage: NextPage = () => {
  return (
    <PWALayout noLayout hideHeader hideNavBar>
      <Profiles />
    </PWALayout>
  );
};

export async function getServerSideProps({ params }: any) {
  return {
    props: {
      id: params?.id,
    } as any,
  };
}

export default ProfilesPage;
